import { create } from 'zustand';

export default create((set) => ({
  error: '',
  setError: (error) => set({ error }),
}));

export const errorSelector = (state) => state.error;
export const setErrorActionSelector = (state) => state.setError;
